import { createFileRoute, redirect } from '@tanstack/react-router';

import { type PermittedPathCandidate, resolveFirstPermittedPath } from '@/lib/route-guards/permission-guard';

const CRM_LANDING_CANDIDATES: readonly PermittedPathCandidate[] = [
	{ to: '/crm/my-work', anyOf: ['leads.read.own', 'leads.read.all', 'deals.read.own', 'deals.read.all'] },
	{ to: '/crm/reporting', anyOf: ['crmReporting.read'] },
	{ to: '/crm/leads', anyOf: ['leads.read.own', 'leads.read.all'] },
	{ to: '/crm/pipeline', anyOf: ['deals.read.own', 'deals.read.all'] },
	{ to: '/crm/contacts', anyOf: ['contacts.read'] },
	{ to: '/crm/companies', anyOf: ['clients.read'] },
	{ to: '/crm/catalog', anyOf: ['productCatalog.read'] },
];

export const Route = createFileRoute('/_authenticated/_app/crm/')({
	beforeLoad: async ({ context }) => {
		const to = await resolveFirstPermittedPath({
			context,
			candidates: CRM_LANDING_CANDIDATES,
			fallback: '/dashboard',
		});
		throw redirect({ to });
	},
});
